{
    "CHGJp": {
        "position": {
            "x": 8,
            "y": 8,
            "z": 1
        },
        "jobKey": "ember/wolf-red",
        "key": "CHGJp"
    },
    "CuErn": {
        "position": {
            "x": 9,
            "y": 10,
            "z": 1
        },
        "jobKey": "ember/wolf-red",
        "key": "CuErn"
    },
    "tiTii": {
        "position": {
            "x": 11,
            "y": 10,
            "z": 1
        },
        "jobKey": "ember/wolf-blue",
        "key": "tiTii"
    },
    "WeUp8": {
        "position": {
            "x": 10,
            "y": 9,
            "z": 1
        },
        "jobKey": "ember/wolf-green",
        "key": "WeUp8"
    },
    "M1w80": {
        "position": {
            "x": 32,
            "y": 9,
            "z": 1
        },
        "jobKey": "ember/knight-green",
        "title": "The Green Knight",
        "key": "M1w80"
    },
    "EXpmO": {
        "position": {
            "x": 33,
            "y": 9,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "EXpmO"
    },
    "DqJ6c": {
        "position": {
            "x": 30,
            "y": 10,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "DqJ6c"
    },
    "wGZwA": {
        "position": {
            "x": 31,
            "y": 7,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "wGZwA"
    },
    "l3K0M": {
        "position": {
            "x": 33,
            "y": 11,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "l3K0M"
    },
    "TRk5q": {
        "position": {
            "x": 8,
            "y": 9,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "TRk5q"
    },
    "crescent": {
        "position": {
            "x": 55,
            "y": 10,
            "z": 1
        },
        "jobKey": "ember/crescent",
        "affiliation": "death",
        "key": "crescent"
    },
    "RuhvJ": {
        "position": {
            "x": 54,
            "y": 12,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "RuhvJ"
    },
    "cACM3": {
        "position": {
            "x": 55,
            "y": 7,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "cACM3"
    },
    "yDK7-": {
        "position": {
            "x": 57,
            "y": 9,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "yDK7-"
    }
}